import React from 'react';
import NameAndNumber from '../../../types/report/NameAndNumber';
import { ReactComponent as SearchIcon } from '../../Common/BootstrapIcons/search.svg';
import { ReactComponent as ClearIcon } from '../../Common/BootstrapIcons/close.svg';
import CustomIcon from '../BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../BootstrapIcons/Tooltip/IconTooltip';
import './styles.scss';
interface Props {
    options: NameAndNumber[];
    onSearch: (options: NameAndNumber[]) => void;
    label: string;
    onClearClick: () => void;
}

interface State {
    value: string;
    matchedOptions: NameAndNumber[];
    showMatches: boolean;
}

class AutocompleteInput extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            value: '',
            matchedOptions: [],
            showMatches: false
        }

        this.onChange = this.onChange.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
    }

    onChange(e: any) {

        let matchedOptions = this.tryMatch(e.target.value);

        this.setState({ value: e.target.value, matchedOptions, showMatches: matchedOptions.length > 0 });
    }

    tryMatch(value: string): NameAndNumber[] {

        let resultOptions: NameAndNumber[] = [];

        this.props.options.forEach(x => {
            let words = x.name.split(' ');

            let match = words.find(x => x.toLowerCase().indexOf(value.toLowerCase()) > -1);

            if (match) {
                resultOptions.push(x);
            }
        });

        return resultOptions;
    }

    onOptionSelected(option: NameAndNumber) {
        this.setState({ value: option.name, showMatches: false }, () => { this.props.onSearch([option]); });
    }

    onSearchClick(value: string) {

        this.setState({ showMatches: false });

        let options = this.tryMatch(value);

        this.props.onSearch(options);
    }

    render(): JSX.Element {
        return (
            <div className='margin-left-10px'>
                <div className='autocomplete'>
                    <div className='input-container'>
                        <input autoComplete='off' className='input-field' value={this.state.value} type='text' onChange={this.onChange} name={`${this.props.label}`} placeholder={`${this.props.label}`} />
                    </div>
                    <button className='custom-icon-button autocomplete-button' onClick={() => this.onSearchClick(this.state.value)}>
                        <CustomIcon icon={SearchIcon} title={iconTooltip.search} />
                    </button>
                    <button className='custom-icon-button autocomplete-button' onClick={() => this.setState({ value: '', showMatches: false }, () => this.props.onClearClick())}>
                        <CustomIcon icon={ClearIcon} title={iconTooltip.clear} />
                    </button>
                </div>
                {
                    this.state.showMatches &&
                    <ul className='results'>
                        {this.state.matchedOptions.map(x => {
                            return <li onClick={() => this.onOptionSelected(x)}>{x.name}</li>
                        })
                        }
                    </ul>
                }
            </div>
        )
    }
}

export default AutocompleteInput;